import { CaretDown, Question } from "@phosphor-icons/react";
import { useState } from "react";

const FrequentAnswer = ({
  question,
  answer,
}: {
  question: React.ReactNode;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex items-center justify-between cursor-pointer gap-3"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="leading-tight">{question}</div>
        <button>
          <CaretDown
            size={18}
            className="inline-block mb-0.5 opacity-50 transition-transform duration-300"
            weight="bold"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
      </div>
      {isOpen && (
        <div className="font-light mt-2 border-b border-h-neutral-90 pb-4 flex flex-col gap-2">
          {answer}
        </div>
      )}
    </div>
  );
};

const FrequentAnswers = ({
  title = "Preguntas frecuentes",
  faqs = [],
  initialCount = 3,
}: {
  title?: string;
  faqs: {
    question: React.ReactNode;
    answer: React.ReactNode;
  }[];
  initialCount?: number;
}) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <div className="bg-white rounded-xl shadow px-6 py-5 md:py-6 flex flex-col gap-6 relative overflow-hidden">
      <div className="text-base font-medium">
        {title}{" "}
        <Question size={18} className="inline-block mb-0.5" weight="bold" />
      </div>
      <div className="flex flex-col gap-4">
        {faqs.slice(0, showAll ? faqs.length : initialCount).map((faq, index) => (
          <FrequentAnswer key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
      {faqs.length > initialCount && (
        <button
          className="text-h-primary font-medium text-right"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Ver menos" : "Ver más"}
        </button>
      )}
    </div>
  );
};

export default FrequentAnswers;
